import * as R from 'ramda'
import { useState } from 'react'
import PropTypes from 'prop-types'

const useTableDelete = ({
  asyncDelete,
  onDeleteSuccessPromise,
  showErrorDialogue,
  getCheckedData,
}) => {
  const initialState = {
    data: [],
    isPending: false,
  }
  const [pendingDeleteState, setPendingDeleteState] = useState(initialState)
  const lensData = R.lensProp('data')
  const viewPendingData = R.view(lensData)

  const isOpenDeleteConfirmation = !R.compose(
    R.isEmpty,
    viewPendingData,
  )(pendingDeleteState)

  const handlerDeleteOne = (cell) => {
    setPendingDeleteState((state) => ({
      ...state,
      data: [cell.original],
    }))
  }
  const handlerDeleteAll = () => {
    setPendingDeleteState((state) => ({
      ...state,
      data: getCheckedData(),
    }))
  }
  const onConfirmDelete = () => {
    setPendingDeleteState((state) => ({
      ...state,
      isPending: true,
    }))
    const ids = R.compose(
      R.map(R.prop('id')),
      viewPendingData,
    )(pendingDeleteState)

    asyncDelete(ids)
      .then(() => {
        setPendingDeleteState(initialState)
        return onDeleteSuccessPromise()
      })
      .catch((error) => {
        setPendingDeleteState(initialState)
        showErrorDialogue(error)
      })
  }
  const onCancelDelete = () => {
    setPendingDeleteState(initialState)
  }

  const pendingDisplayItems = viewPendingData(pendingDeleteState)

  const afterConfirmPending = R.prop('isPending')(pendingDeleteState)

  return {
    afterConfirmPending,
    pendingDisplayItems,
    isOpenDeleteConfirmation,
    onConfirmDelete,
    onCancelDelete,
    handlerDeleteAll,
    handlerDeleteOne,
  }
}

useTableDelete.propTypes = {
  PropTypes: PropTypes.func.isRequired,
  onDeleteSuccessPromise: PropTypes.func.isRequired,
  showErrorDialogue: PropTypes.func.isRequired,
  getCheckedData: PropTypes.func.isRequired,
}

export default useTableDelete
